module.exports = __webpack_public_path__ + "img/teacher_men.e41dd20e.png";